import { render, staticRenderFns } from "./serviceimplementation.vue?vue&type=template&id=b6ab0a94"
import script from "./serviceimplementation.vue?vue&type=script&lang=js"
export * from "./serviceimplementation.vue?vue&type=script&lang=js"
import style0 from "./serviceimplementation.vue?vue&type=style&index=0&id=b6ab0a94&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports